import _ from "lodash";
import {
  FilterQueryTypes,
  IFilterQuery,
} from "../components/boxitFilter/types";
import { endOfDay, format, parse, startOfDay } from "date-fns";

const getFilterString = (
  filters: Record<string, string | null>,
  filterQueries?: IFilterQuery[]
) => {
  return !_.isEmpty(filters)
    ? Object.keys(filters)
        .reduce((data: string[], key) => {
          const value = filters[key];
          const query = filterQueries?.find(
            (filterQuery) => filterQuery.fieldName === key
          );
          if (filters[key] && key?.includes("$gte") && value) {
            data.push(
              `&${key.split("$")[0]}[$gte]=${format(startOfDay(parse(value, "dd-MM-yyyy", new Date())), "yyyy-MM-dd'T'HH:mm:ss'Z'")}`
            );
          } else if (filters[key] && key?.includes("$lte") && value) {
            data.push(
              `&${key.split("$")[0]}[$lte]=${format(
                endOfDay(parse(value, "dd-MM-yyyy", new Date())),
                "yyyy-MM-dd'T'HH:mm:ss'Z'"
              )}`
            );
          } else if (filters[key] && key?.includes("$like") && value) {
            data.push(`&${key.substring(0, key.length - 5)}[$like]=*${value}*`);
          } else if (
            filters[key] &&
            query &&
            query.query !== FilterQueryTypes.EQUAL
          ) {
            data.push(`&${key}[${query.query}]=${value}`);
          } else if (filters[key]) {
            data.push(`&${key}=${value}`);
          }
          return data;
        }, [])
        .join("")
    : "";
};

export default getFilterString;
